import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

type WorkflowProcessPayload = {
  activityItemId: string;
};

const workflowProcess = async (
  workflowProcessPayload: WorkflowProcessPayload,
) => {
  return await apiInputService
    .post(
      "workflow/process",
      {},
      {
        params: workflowProcessPayload,
      },
    )
    .then(() => {});
};

export const useWorkflowProcess = (options?: any) => {
  return useMutation(workflowProcess, {
    ...options,
  });
};
